import React from 'react'
import InvoiceBook from '../components/BookInvoiceForm';
import { useSelector } from "react-redux"
import { RootState } from '../store/store';
import { BookData } from '../types/bookInvoice';


const InfoPage: React.FC = () =>{
const bookInvoices = useSelector((state: RootState) => state.bookInvoices as BookData[]);
      console.log(bookInvoices[0])
    return (
        <InvoiceBook></InvoiceBook>
    ) 
}
export default InfoPage;